module.exports = __webpack_public_path__ + "img/interpackmaxi_dg_k.b78a3676.png";